import React, { useEffect } from "react";
import { useState, useContext } from "react";
import * as request from "superagent";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { makeStyles, Theme, createStyles } from "@mui/styles";

import {
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel
  } from '@mui/material';
import DefinitionSection from "~common/form/definition-section-fc";
import {
  DataContext,
  PolicyContext,
  DirtyContext,
} from "~common/form/icg-definition-data-provider";

import Renderers from "~common/lib/renderers";
import CountEditor from '~dashboard/components/elements/count-editor-fc';
import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
// import AggregationEditor from '~dashboard/components/elements/aggregation-editor';

CountEditor.register()
// AggregationEditor.register()

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalContent: {
      width: 500,
    },
    modalTitle: {
      padding: "0px 0px 20px 0px",
    },
    gridItem: {
      paddingBottom: "0px !important;",
      paddingTop: "0px !important;",
    },
    controlContainer: {
      width: "100%",
      padding: 0,
    },
    inputLabel: {
      width: "100%",
    },
    dangerButton: {
      backgroundColor: "#af0202",
      "&:hover": {
        backgroundColor: "#5D0A0A !important",
      },
    },
    configViewArea: {
      paddingTop: 15,
      paddingBottom: 15,
    },
    cardType: {
      width: 250,
    },
  })
);

interface DashboardCardConfigProps  {
    classes: any;
    config: any;
    elementType: any;
    onConfigChange: Function;
    results: any;
}
export  const DashboardCardConfig: React.FC<DashboardCardConfigProps> = ({
    classes,
    config,
    elementType,
    onConfigChange,
    results
}) => {
    const _classes = useStyles()
    const [_config, setConfig] = useState(config || {elementType: "count"})
    const [configComplete, setConfigComplete] = useState(false)
    const [configElementType, setConfigElementType] = useState({"key":"count", "uiAttributes":{"configRenderer":"CountConfigRenderer"}})
    var Renderer = Renderers.find(configElementType.uiAttributes.configRenderer);
    var configView: any = null;

    console.log("config", config)

    const handleConfigChange = (data:any) => {
        if (data && data.title) {
            config.title = data.title;
            setConfig(config)
        }

    }

    if (Renderer) {
        configView = (
            <Renderer
                classes={{}}
                element={config}
                elementType={configElementType}
                onConfigChange={handleConfigChange}
                results={results}
            />
        );
    } else {
        configView = (
            <div>Uh Oh!  Something has gone wrong</div>
        );
    }


    return (
        <DefinitionDataProvider>
            <div>
        {/* <div>Element Type Selector Here</div> */} {/* use this line instead of the line below when an element type selector is made*/}
        <div>

            <FormControl style={{marginLeft:10}}>
              <InputLabel
                shrink={true}
                htmlFor="configElementType">
                Card Type 
              </InputLabel>
              <Select
                className={_classes.cardType}
                name="configElementType"
                value={config.elementType}
                >
                  <MenuItem
                    key="count"
                    value="count">
                    Count Card
                  </MenuItem>
              </Select>
              <FormHelperText ></FormHelperText>
            </FormControl>
        </div>
        <div className={_classes.configViewArea}>{configView}</div>
      </div>
        </DefinitionDataProvider>
    )
}

export default DashboardCardConfig;
